export default __webpack_public_path__ + "static/media/ca_ad_banner_v2.743140b0.jpg";